import axios from 'axios'
export default {
  methods: {
    rec_bandeja_escalamientos (idUsuario) {
      const urlroute = this.$store.getters.getUrl + 'escalamientos_usuario/' + idUsuario
      this.loadingForm = true
      axios({
        url: urlroute,
        method: 'GET',
        data: null,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters.getToken
        }
      }).then(response => {
        this.objGlobal.items_escalamientos = response.data
      }).catch(error => {
        console.log('error ' + error)
      }).finally(() => {
        this.loadingForm = false
      })
    },
    rec_bandeja_escalamientos_filtro (idUsuario, pAnio, pMes, pEstado, pFiltrar, pCodigo) {
      const urlroute = this.$store.getters.getUrl + 'escalamientos_usuario_filtro/'
      const data = { usuario: idUsuario, anio: pAnio, mes: pMes, estado: pEstado, filtrar: pFiltrar, codigo: pCodigo }
      this.objs.loading = true
      axios({
        url: urlroute,
        method: 'POST',
        data: data,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters.getToken
        }
      }).then(response => {
        // console.log(response.data)
        this.objGlobal.items_escalamientos = response.data
      }).catch(error => {
        console.log('error ' + error)
      }).finally(() => {
        this.objs.loading = false
      })
    },
    // Asesores habilitados de un area, para el dialogo de reasignacion.
    // No se usa items_areas (form_bandeja) porque ese listado trae tambien los inactivos:
    // lo necesita el filtro de bandeja para poder buscar los pendientes de quien se desactivo.
    rec_bandeja_asesores_activos (areaId) {
      const urlroute = this.$store.getters.getUrl + 'asesores_activos/' + areaId
      this.objs.loadingAsesores = true
      this.objs.error = ''
      axios({
        url: urlroute,
        method: 'GET',
        data: null,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters.getToken
        }
      }).then(response => {
        this.objs.items_asesores = response.data
      }).catch(error => {
        this.objs.error = this.rec_bandeja_mensaje_error(error, 'No fue posible cargar los asesores activos')
      }).finally(() => {
        this.objs.loadingAsesores = false
      })
    },
    rec_bandeja_reasignar (gestionId, idEscaladoa, observacion) {
      const urlroute = this.$store.getters.getUrl + 'escalamiento_reasignar'
      const data = { gestion_id: gestionId, id_escaladoa: idEscaladoa, observacion: observacion }
      this.objs.loading = true
      this.objs.error = ''
      axios({
        url: urlroute,
        method: 'POST',
        data: data,
        headers: {
          Authorization: 'Bearer ' + this.$store.getters.getToken
        }
      }).then(response => {
        this.reasignado(response.data)
      }).catch(error => {
        this.objs.error = this.rec_bandeja_mensaje_error(error, 'No fue posible reasignar la PQRS')
      }).finally(() => {
        this.objs.loading = false
      })
    },
    // 403 = no es supervisor activo, 422 = validacion (asesor inactivo, PQRS cerrada...).
    rec_bandeja_mensaje_error (error, pDefecto) {
      let mensaje = pDefecto
      if (error.response) {
        if (error.response.status === 403) {
          mensaje = 'No tiene permiso para reasignar PQRS'
        } else if (error.response.status === 422 && error.response.data) {
          if (error.response.data.error) {
            mensaje = error.response.data.error
          } else if (error.response.data.errors) {
            mensaje = Object.values(error.response.data.errors).join(' ')
          }
        }
      }
      console.log('error ' + error)
      return mensaje
    }
  }
}
